import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDigitalApplicationBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 17.690104 11.976896 C 18.992188 13.278979 18.992188 15.388354 17.690104 16.690437 C 16.388021 17.989917 14.278646 17.989917 12.976562 16.690437 C 11.674479 15.388354 11.674479 13.278979 12.976562 11.976896 C 14.278646 10.674812 16.388021 10.674812 17.690104 11.976896 ",
				transform: "matrix(1.5,0,0,1.5,-6,-5.5005)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 9.865125 5.496062 L 9.865125 5.501271 L 9.865125 5.496062 ",
				transform: "matrix(1.5,0,0,1.5,-4.9305,-2.748)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 7.323812 5.496062 L 7.323812 5.501271 L 7.323812 5.496062 ",
				transform: "matrix(1.5,0,0,1.5,-3.6615,-2.748)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 4.776896 5.488854 L 4.776896 5.496667 L 4.776896 5.488854 ",
				transform: "matrix(1.5,0,0,1.5,-2.388,-2.745)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 2.000333 8.000333 L 13.333667 8.000333 ",
				transform: "matrix(1.5,0,0,1.5,-1.0005,-4.0005)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 13.333667 8.611979 L 13.333667 4.333333 C 13.333667 3.596354 12.737312 3 12.000333 3 L 3.333667 3 C 2.596687 3 2.000333 3.596354 2.000333 4.333333 L 2.000333 11.666667 C 2.000333 12.403646 2.596687 13 3.333667 13 L 8.945646 13 ",
				transform: "matrix(1.5,0,0,1.5,-1.0005,-1.5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 17.741104 14.890083 L 15.889542 16.741646 L 14.777563 15.629667 ",
				transform: "matrix(1.5,0,0,1.5,-7.389,-7.4445)"
			})
		]
	})
});
export default SvgDigitalApplicationBlue;
